import { Component, OnInit } from '@angular/core';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { UtilityService } from 'src/app/services/utility.service';
import { ThemeService } from 'src/app/services/theme.service';
import { SessionService } from 'src/app/services/session.service';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { ActiveHospitalService } from 'src/app/services/active-hospital.service';
import { environment } from 'src/environments/environment';
import { messages } from '../../../../../common/messages'
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';
import { regex ,EmailNoWhitespaceValidator} from '../../../../../common/regex';
@Component({
    selector: 'app-pcv-sign-in',
    templateUrl: './pcv-sign-in.component.html',
    styleUrls: ['./pcv-sign-in.component.scss'],
    standalone: false
})
export class PcvSignInComponent implements OnInit {

  assets = environment.assets;
  public form: any;
  message: any
  emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  passwordRegex = regex.pattern.PASSWORD
  hide = true;
  hide1 = true;
  hide2 = true;
  icVisibility = icVisibility;
  icVisibilityOff = icVisibilityOff;
  isSpecialtyIntakeEnabled: boolean = false;
  dvmName: string = 'Primary Care Veterinarian';
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private api: ApiService,
    private utility: UtilityService,
    public themeService: ThemeService,
    private sessionService: SessionService,
    private featureFlagService: FeatureFlagService,
    private activeHospitalService: ActiveHospitalService) { }

  ngOnInit(): void {
    this.dvmName = this.featureFlagService.isSpecialtyIntakeEnabled() ? 'DVM' : 'Primary Care Veterinarian';
    this.message = messages
    this.isSpecialtyIntakeEnabled = this.featureFlagService.isSpecialtyIntakeEnabled();
    this.setupSigninForm();
  }

  setupSigninForm() {
    this.form = this.fb.group({
      email: [null,
        Validators.compose([
          Validators.required,
          EmailNoWhitespaceValidator,
          ])],

      password: [null,
        Validators.compose([
          Validators.required,
          this.noWhitespaceValidator,
          Validators.pattern(this.passwordRegex)])]
    });
  }

  noWhitespaceValidator(control: any) {
    const isWhitespace = (control.value || '').match(/\s/g)
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  signIn(userData: any) {
    this.utility.setSpinner(true)
    userData['userType'] = ''
    this.api.apiRequest("post", "user/signin", userData)
      .subscribe(result => {
        this.utility.setSpinner(false)

        if (result.status == "success") {
          this.utility.openSnackBar("Signin successful.", "Ok")
          let userData = result.data;
          // Check for returnUrl parameter
          const returnUrl = this.route.snapshot.queryParams['returnUrl'];

          if (userData.userType == 'pcv') {
            if (returnUrl) {
              this.router.navigateByUrl(returnUrl);
            } else if (this.isSpecialtyIntakeEnabled) {
              // Specialty intake enabled: redirect to view-cases
              this.router.navigate(['pcv/view-cases']);
            } else if (userData.status == 'active') {
              // Legacy: redirect to day2 dashboard
              this.router.navigate(['pcv/dashboard/day2']);
            } else {
              // Legacy: redirect to dashboard
              this.router.navigate(['pcv/dashboard']);
            }
          }

          // Store the values in local storage (before navigation)
          localStorage.setItem("endUserEmail", userData.email)
          localStorage.setItem("endUserId", userData._id)
          localStorage.setItem("endUserType", userData.userType)
          localStorage.setItem("endUserFullName", userData.firstName + ' ' + userData.lastName)
          localStorage.setItem("endUserFirstName", userData.firstName)
          localStorage.setItem("endUserLastName", userData.lastName)
          localStorage.setItem("accessToken", userData.accessToken)
          localStorage.setItem("contactNumber", userData.contactNumber)
          localStorage.setItem("status", userData.status)

          // Store hospital-related data for VC users (specialty intake only)
          if (this.isSpecialtyIntakeEnabled) {
            if (userData.hospitalCode) {
              localStorage.setItem('hospitalCode', userData.hospitalCode);
            }
            if (userData.hospitalRole) {
              localStorage.setItem('hospitalRole', userData.hospitalRole);
            }
            if (userData.staffRole) {
              localStorage.setItem('staffRole', userData.staffRole);
            }
            if (userData.practiceName) {
              localStorage.setItem('practiceName', userData.practiceName);
            }
            // Multi-site: initialize accessible hospitals
            if (userData.accessibleHospitals) {
              this.activeHospitalService.initialize(userData.accessibleHospitals);
            }
          }

          // Navigate based on user type — always preselect primary site, user changes via navbar
          if (userData.userType === 'vc') {
            if (returnUrl) {
              this.router.navigateByUrl(returnUrl);
            } else if (this.isSpecialtyIntakeEnabled) {
              this.router.navigate(['pcv/view-cases']);
            } else {
              this.router.navigate(['pcv/my-vc-profile']);
            }
          }

          if (userData.profilePic) {
            localStorage.setItem("profilePic", environment.documentBaseUrl + "profilePic/" + userData.profilePic)

          }

          // Start session monitoring for auto-logout
          this.sessionService.startSession(false);

        } else {
          if (result.data.invalidEmail) {
            this.form.controls['email'].setErrors({ 'invalidEmail': true })
          } else if (result.data.invalidPassword) {

            this.form.controls['password'].setValue('');
            this.form.controls['password'].markAsUntouched();
            this.form.controls['password'].setErrors({ 'invalidPassword': true });

          } else if (result.data.userNotActive) {
            this.form.controls['email'].markAsUntouched();
            this.form.controls['email'].setErrors({ 'userNotActive': true })

          } else if (result.data.accountNotVerified) {
            this.form.controls['email'].markAsUntouched();
            this.form.controls['email'].setErrors({ 'accountNotVerified': true })
          }
          else if (result.data.otherAccount) {
            this.form.controls['email'].markAsUntouched();
            this.form.controls['email'].setErrors({ 'invalidLoginType': true })
          }
          else {
            this.form.controls['email'].markAsUntouched();
            this.form.controls['email'].setErrors({ 'differentAccount': false })
          }
        }


      }, (err) => {
        this.utility.setSpinner(false)
        // this.router.navigate(["/error/404"])
      })

  }

  /**
   * Initiate SAML SSO login
   * Only available when SPECIALTY_INTAKE_ENABLED feature flag is true
   */
  loginWithEntra(): void {
    if (!this.isSpecialtyIntakeEnabled) {
      return;
    }

    // SAML SP-initiated: direct browser redirect to backend login endpoint
    const serverUrl = this.api.serverUrl;
    window.location.href = `${serverUrl}/api/auth/saml/login`;
  }

}
